// extracted by mini-css-extract-plugin
export default {"container":"sidebar_container__8wvuG","iconsignout":"sidebar_iconsignout__EFBht"};